import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

const Vodic = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <div className="max-w-4xl mx-auto p-6 bg-white shadow-lg rounded-lg">
      <h1 className="text-3xl font-bold text-center mb-6">
        Korisnički vodič za NutriTrans
      </h1>
      <p className="text-lg text-gray-700 mb-4">
        Dobrodošli u NutriTrans aplikaciju! Ovaj vodič će vam pomoći da brzo i
        jednostavno savladate osnovne funkcionalnosti i iskoristite sve
        prednosti aplikacije za postizanje vaših zdravstvenih i nutritivnih
        ciljeva.
      </p>

      <h2 className="text-2xl font-semibold mt-6">
        1. Početna stranica i registracija
      </h2>
      <p className="text-gray-700">
        <strong>Kako da započnete sa NutriTrans?</strong>
      </p>
      <ul className="list-disc ml-6 text-gray-700">
        <li>Posetite početnu stranicu NutriTrans.</li>
        <li>Kliknite na dugme "Registracija" u gornjem desnom uglu.</li>
        <li>Unesite osnovne podatke: ime, prezime, email, lozinku itd.</li>
        <li>Nakon potvrde emaila, prijavite se na platformu.</li>
      </ul>

      <br />

      <p className="text-gray-700">
        <strong>📌 Prikaz početne stranice i blog sekcije:</strong>
      </p>

      <img
        src={`${process.env.PUBLIC_URL}/img/Slike/Naslovna_strana.png`}
        alt="Slika"
      />

      <h2 className="text-2xl font-semibold mt-6">
        2. Prvi koraci – Unos osnovnih podataka
      </h2>
      <ul className="list-disc ml-6 text-gray-700">
        <li>Ime i prezime</li>
        <li>Datum rođenja</li>
        <li>Pol</li>
        <li>Težina i visina</li>
        <li>Email i kontakt telefon (opciono)</li>
      </ul>
      <p className="text-gray-700">
        Ovi podaci su neophodni za personalizovane preporuke.
      </p>

      <br />

      <p className="text-gray-700">
        <strong>📌 Prikaz ekrana za unos podataka:</strong>
      </p>

      <img
        src={`${process.env.PUBLIC_URL}/img/Slike/Prvi_podaci.png`}
        alt="Slika"
      />

      <h2 className="text-2xl font-semibold mt-6">
        3. Navigacija kroz aplikaciju
      </h2>
      <ul className="list-disc ml-6 text-gray-700">
        <li>Dashboard – pregled svih podataka na jednom mestu.</li>
        <li>Osnovni podaci – mesto gde ažurirate lične informacije.</li>
        <li>
          Ciljevi – postavljanje i praćenje ciljeva (mršavljenje, održavanje
          težine, povećanje mišićne mase).
        </li>
        <li>Fizički parametri – analiza telesnih podataka.</li>
        <li>Ishrana – Izveštaji, preporuke i dnevni unos kalorija.</li>
        <li>Namirnice – baza namirnica sa nutritivnim vrednostima.</li>
        <li>Planovi ishrane – generisanje personalizovanog plana.</li>
      </ul>

      <br />

      <p className="text-gray-700">
        <strong>📌 Prikaz glavne navigacije:</strong>
      </p>

      <img
        src={`${process.env.PUBLIC_URL}/img/Slike/Prvi_koraci.png`}
        alt="Slika"
      />

      <br />

      <p className="text-gray-700">
        <strong>Fizički parametri</strong>
      </p>

      <p className="text-gray-700">
        Unos fizičkih podataka kao što su visina, težina, mere tela, krvna grupa
        i nivo fizičke aktivnosti.
      </p>

      <img
        src={`${process.env.PUBLIC_URL}/img/Slike/Fizicki_parametri.png`}
        alt="Slika"
      />

      <br />

      <p className="text-gray-700">
        <strong>Ishrana</strong>
      </p>

      <p className="text-gray-700">
        Personalizacija načina ishrane, unos broja obroka dnevno i beleženje
        nutritivnih navika.
      </p>

      <img
        src={`${process.env.PUBLIC_URL}/img/Slike/Ishrana.png`}
        alt="Slika"
      />

      <br />

      <p className="text-gray-700">
        <strong>Namirnice</strong>
      </p>

      <p className="text-gray-700">
        Spisak dostupnih namirnica, odabir omiljenih i izbegavanih namirnica za
        personalizovani plan ishrane.
      </p>

      <img
        src={`${process.env.PUBLIC_URL}/img/Slike/Namirnice.png`}
        alt="Slika"
      />

      <h2 className="text-2xl font-semibold mt-6">
        4. Podešavanje ciljeva i praćenje napretka
      </h2>
      <p className="text-gray-700">
        Sistem analizira vaše podatke i nudi plan ishrane i aktivnosti. Napredak
        se meri kroz grafikone i izveštaje.
      </p>

      <ul className="list-disc ml-6 text-gray-700">
        <li>U sekciji "Ciljevi" definišite šta želite da postignete.</li>
        <li>Sistem analizira vaše podatke i nudi plan ishrane i aktivnosti.</li>
        <li>Napredak se meri kroz grafikone i izveštaje.</li>
      </ul>

      <br />

      <p className="text-gray-700">
        <strong>📌 Prikaz podešavanja ciljeva:</strong>
      </p>

      <img
        src={`${process.env.PUBLIC_URL}/img/Slike/Ciljevi_1.png`}
        alt="Slika"
      />

      <h2 className="text-2xl font-semibold mt-6">
        5. Personalizovani planovi ishrane
      </h2>
      <p className="text-gray-700">
        NutriTrans koristi veštačku inteligenciju da kreira planove ishrane na
        osnovu vaših podataka.
      </p>
      <ul className="list-disc ml-6 text-gray-700">
        <li>Generisanje plana traje nekoliko minuta.</li>
        <li>Možete preuzeti plan u sekciji "Planovi ishrane".</li>
      </ul>

      <br />

      <p className="text-gray-700">
        <strong>Prikaz kreiranja plana ishrane:</strong>
      </p>

      <img
        src={`${process.env.PUBLIC_URL}/img/Slike/Priprema_izvestaja.png`}
        alt="Slika"
      />

      <h2 className="text-2xl font-semibold mt-6">
        6. Kalkulatori i analiza parametara
      </h2>
      <ul className="list-disc ml-6 text-gray-700">
        <li>BMI (Indeks telesne mase)</li>
        <li>BMR (Bazalni metabolizam)</li>
        <li>TDEE (Ukupna dnevna potrošnja energije)</li>
      </ul>

      <br />

      <p className="text-gray-700">
        <strong>Prikaz kalkulatora i fizičkih parametara:</strong>
      </p>

      <img
        src={`${process.env.PUBLIC_URL}/img/Slike/Kalkulator_1.png`}
        alt="Slika"
      />

      <h2 className="text-2xl font-semibold mt-6">
        7. Pretplata i dostupni paketi
      </h2>
      <p className="text-gray-700">
        NutriTrans nudi besplatnu verziju, ali i napredne funkcionalnosti kroz
        plaćene pakete.
      </p>
      <ul className="list-disc ml-6 text-gray-700">
        <li>U sekciji "Pretplata" možete pregledati dostupne pakete.</li>
        <li>
          Paketi uključuju osnovne i napredne funkcije sa različitim nivoima
          podrške.
        </li>
      </ul>

      <br />

      <p className="text-gray-700">
        <strong>Prikaz pretplate i opcija:</strong>
      </p>

      <img
        src={`${process.env.PUBLIC_URL}/img/Slike/Pretplata_1.png`}
        alt="Slika"
      />

      <h2 className="text-2xl font-semibold mt-6">8. Blog i edukacija</h2>
      <p className="text-gray-700">
        NutriTrans blog donosi savete i informacije o ishrani, zdravlju i
        fitnesu.
      </p>

      <ul className="list-disc ml-6 text-gray-700">
        <li>Možete pretraživati blogove po kategorijama.</li>
        <li>
          Svaki blog je prilagođen korisnicima koji žele da nauče više o zdravom
          načinu života.
        </li>
      </ul>

      <br />

      <p className="text-gray-700">
        <strong>Prikaz blog sekcije:</strong>
      </p>

      <img
        src={`${process.env.PUBLIC_URL}/img/Slike/Svi_blogovi.png`}
        alt="Slika"
      />

      <h2 className="text-2xl font-semibold mt-6">
        9. Najčešće postavljana pitanja (FAQ)
      </h2>
      <p className="text-gray-700">
        U sekciji "Pomoć" možete pronaći odgovore na najčešća pitanja:
      </p>
      <ul className="list-disc ml-6 text-gray-700">
        <li>Kako da se registrujem?</li>
        <li>Kako da otkažem pretplatu?</li>
        <li>Da li su moji podaci sigurni?</li>
      </ul>

      <br />

      <p className="text-gray-700">
        <strong>Prikaz FAQ sekcije:</strong>
      </p>

      <img
        src={`${process.env.PUBLIC_URL}/img/Slike/Naslova_strana_Pitanja_1.png`}
        alt="Slika"
      />
    </div>
  );
};

export default Vodic;
